import React, { useState, useEffect } from 'react';

const UserForm = ({ user, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    blocked: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setFormData({
        email: user.email || '',
        password: '', // Always empty for edit mode
        blocked: user.blocked !== undefined ? user.blocked : false
      });
    } else {
      setFormData({
        email: '',
        password: '',
        blocked: false
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Prepare data for submission
      const submitData = { ...formData };
      
      // Generate username from email
      submitData.username = formData.email.split('@')[0];
      
      // Set default values
      submitData.confirmed = true;
      submitData.role = 1; // Authenticated user role
      
      // Don't send empty password for updates
      if (user && !submitData.password) {
        delete submitData.password;
      }

      await onSubmit(submitData);
    } catch (err) {
      setError(err.message || 'Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card mb-4">
      <div className="card-header">
        <h5 className="mb-0">
          {user ? 'Modifier l\'utilisateur' : 'Ajouter un utilisateur'}
        </h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {/* <small className="text-muted">
                Le nom d'utilisateur sera généré automatiquement à partir de l'email
              </small> */}
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label className="form-label">
                Mot de passe {!user && <span className="text-danger">*</span>}
              </label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required={!user}
                placeholder={user ? 'Laisser vide pour ne pas changer' : 'Mot de passe'}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="blocked"
                  checked={formData.blocked}
                  onChange={handleInputChange}
                />
                <label className="form-check-label">
                  Compte bloqué
                </label>
              </div>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <div className="d-flex gap-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Sauvegarde...' : 'Sauvegarder'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;